export default __webpack_public_path__ + "static/media/party-popper.565262fd.svg";